import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { STATUS_KEYS } from './budgetColumns';

/**
 * Texts of Gelir & Gider Yönetimi (`budget.*`). Stored values stay Turkish
 * ('Alındı', 'Beklemede', 'Pasif', …); `statusLabel` only labels them. Excel
 * files stay Turkish.
 */
const useBudgetText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`budget.${key}`, vars), [t]);
  const statusLabel = useCallback((value) => (STATUS_KEYS[value] ? t(`budget.status.${STATUS_KEYS[value]}`) : value || ''), [t]);
  /** Same rule as the old table: empty or zero → '-', otherwise two decimals. */
  const formatAmount = useCallback((val) => {
    const n = parseFloat(val);
    if (!n || Number.isNaN(n)) return '-';
    return n.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }, [locale]);
  const formatInt = useCallback((val) => {
    const n = parseFloat(val);
    if (!n || Number.isNaN(n)) return '-';
    return n.toLocaleString(locale);
  }, [locale]);
  /** Totals of the tiles and the import preview (up to two decimals). */
  const formatTotal = useCallback((n) => (Number(n) || 0).toLocaleString(locale, { maximumFractionDigits: 2 }), [locale]);
  /** 'YYYY-MM-DD' → short date in the current language; other text stays as it is. */
  const formatDate = useCallback((value) => {
    if (!value) return '';
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
    if (!match) return String(value);
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return date.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
  }, [locale]);
  return { t, language, locale, label, statusLabel, formatAmount, formatInt, formatTotal, formatDate };
};

export default useBudgetText;
